import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API, useLoad } from "../lib/api";
import { SponsoredTag } from "./kit";

export function Sponsored({ placement, categoryId }: { placement: string; categoryId?: string }) {
  const q = `/public/sponsored?placement=${placement}${categoryId ? `&category_id=${categoryId}` : ""}`;
  const { data } = useLoad<any[]>(q);
  if (!data || data.length === 0) return null;
  const click = (id: string) => axios.post(`${API}/public/sponsored/${id}/click?placement=${placement}`).catch(() => {});
  return (
    <aside className="sponsored-zone" aria-label="Sponsored placements" data-testid="sponsored-section">
      <div className="mb-3 flex items-center justify-between gap-2">
        <SponsoredTag />
        <span className="text-xs text-[#8a5300]">Paid placement · does not affect organic results</span>
      </div>
      <ul className="space-y-3">
        {data.map((ad) => (
          <li key={ad.id} className="rounded bg-white p-3" data-testid={`sponsored-ad-${ad.id}`}>
            <p className="font-semibold">{ad.title}</p>
            <p className="text-sm text-[var(--muted)]">{ad.body}</p>
            {ad.ref && (
              <Link to={`/vendors/${ad.ref}`} onClick={() => click(ad.id)} className="mt-1 inline-block text-sm font-semibold text-[var(--blue)] underline" data-testid={`sponsored-ad-link-${ad.id}`}>
                View provider
              </Link>
            )}
          </li>
        ))}
      </ul>
    </aside>
  );
}
